module.exports = __webpack_public_path__ + "static/media/EbitNielsen-Logo2020-BkBlack.9a629f41.9a629f41.png";